"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
class FederatedApp {
}
_a = FederatedApp;
FederatedApp.getAppRoot = (appName) => {
    var _b;
    return (_b = window[appName]) === null || _b === void 0 ? void 0 : _b.root;
};
FederatedApp.setAppRoot = (appName, rootElement) => {
    if (!window[appName]) {
        window[appName] = {};
    }
    window[appName].root = rootElement;
};
FederatedApp.isAppInsideShadowRoot = (appName) => {
    var _b;
    return _a.getAppRoot(appName) || ((_b = _a.getAppRoot(appName)) === null || _b === void 0 ? void 0 : _b.getRootNode());
};
FederatedApp.getRenderFederatedApp = async (appName, appModule, appList) => {
    var _b, _c;
    try {
        const factory = await ((_c = (_b = window[appName]) === null || _b === void 0 ? void 0 : _b.get) === null || _c === void 0 ? void 0 : _c.call(_b, appModule));
        if (factory) {
            const { default: render } = factory();
            return render;
        }
        const appImportFunction = appList === null || appList === void 0 ? void 0 : appList[appName];
        if (appImportFunction) {
            return await appImportFunction();
        }
        throw new Error(`Missing federated module render function for app: ${appName}`);
    }
    catch (error) {
        Promise.reject(error);
    }
    return Promise.reject(new Error());
};
exports.default = FederatedApp;
